import { AxiosPromise } from 'axios';
import Api, { baseURL } from '../../configs/AxiosConfig';
import {
  TransactionsCountersResponse,
  TransactionsListRequest,
  TransactionsListResponse,
  TransactionType,
  TransactionTypesResponse,
} from '../../models/TransactionsModels';
import { FileFormat } from '../../models/ImportModels';
import { downloadFile } from '../../utils/files/downloadFile';

const TransactionsService = {
  api: {
    fetchTransactionTypes: (): AxiosPromise<TransactionTypesResponse> => Api.get(`/transactions/transaction-types`, {}),
    fetchTransactionCounters: (params: {
      transactionType: TransactionType;
    }): AxiosPromise<TransactionsCountersResponse> => Api.get(`/transactions/counters`, { params }),
    fetchTransactions: (params: TransactionsListRequest): AxiosPromise<TransactionsListResponse> =>
      Api.post(`/transactions/list`, params),
    exportData: (filter: TransactionsListRequest, format: FileFormat, fileName: string): Promise<void> => {
      // Build query string from params and format
      const queryParams = new URLSearchParams();

      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined) {
          queryParams.append(key, String(value));
        }
      });
      queryParams.append('format', format.toUpperCase());

      return downloadFile({
        url: `${baseURL}/transactions/report/export?${queryParams.toString()}`,
        filename: fileName,
      });
    },
  },
};

export default TransactionsService;
